import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import CustomAlert from '../Common/CustomAlert';
import './CSS/AssignEC.css';

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const AssignEC: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [dateValue, setDateValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [alertState, setAlertState] = useState({
        show: false,
        message: '',
        isSuccess: false
    });

    const schoolCode = searchParams.get('SchoolCode');
    const familyCode = searchParams.get('FamilyCode');
    const login = searchParams.get('Login');
    const teacherLogin = searchParams.get('TeacherLogin');

    const handleCloseAlert = () => {
        setAlertState(prev => ({ ...prev, show: false }));
        if (alertState.isSuccess) {
            window.close();
        }
    };

    const handleAssign = async () => {
        if (!dateValue || dateValue.length !== 10) {
            setAlertState({ show: true, message: 'Please enter the date (dd/mm/yyyy).', isSuccess: false });
            return;
        }

        const parts = dateValue.split('/');
        if (parts.length !== 3) {
            setAlertState({ show: true, message: 'Invalid date format.', isSuccess: false });
            return;
        }

        const [day, month, year] = parts;
        const formattedDate = `${year}-${month}-${day}`;

        setIsLoading(true);

        try {
            const payload = {
                school_code: schoolCode,
                family_code: familyCode,
                login: login,
                set_date: formattedDate,
                teacher_login: teacherLogin
            };

            const response = await fetch(`${API_BASE_URL}api/assign_english_check/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.status === 'success') {
                setAlertState({ show: true, message: 'English Check assigned successfully.', isSuccess: true });
            } else {
                setAlertState({ show: true, message: data.message || 'Failed to assign English Check.', isSuccess: false });
            }
        } catch (error) {
            console.error('Error assigning English Check:', error);
            setAlertState({ show: true, message: 'Failed to assign English Check. Please try again.', isSuccess: false });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <div className="wrapper">
                <h1>Assign English Check</h1>

                <div className="setdate">
                    <span id="lblSetdate">Set Date: </span>
                    <input
                        id="txtSetDate"
                        type="date"
                        value={
                            dateValue
                                ? `${dateValue.split('/')[2]}-${dateValue.split('/')[1]}-${dateValue.split('/')[0]}`
                                : ''
                        }
                        onChange={(e) => {
                            const value = e.target.value;

                            if (value) {
                                const [year, month, day] = value.split('-');
                                setDateValue(`${day}/${month}/${year}`);
                            } else {
                                setDateValue('');
                            }
                        }}
                    />
                </div>

                <div className="btn-placeholder">
                    <button
                        id="btnSave"
                        onClick={handleAssign}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Wait...' : 'Assign'}
                    </button>

                    <button
                        id="btnCancel"
                        onClick={() => window.close()}
                    >
                        Cancel
                    </button>
                </div>
            </div>

            {alertState.show && (
                <CustomAlert
                    message={alertState.message}
                    onClose={handleCloseAlert}
                />
            )}
        </div>
    );
};

export default AssignEC;
